<template>
  <div class="container-fluid">
    <div class="row" v-if="highscoreLookupError !== null">
      <div class="col-12">
        <div class="alert alert-warning">
          Highscore lookup is currently having issues, please use manual stat entry!
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 mb-3">
        <h1 class="text-center">OSRS Gear Optimizer</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">

        <div class="row">
          <div class="col-xl-6 col-sm-12 mb-0">
            <PlayerLookup :player="player"
                          @lookup="(newPlayer) => {this.player = newPlayer}"></PlayerLookup>

          </div>
          <div class="col-xl-6 col-sm-12">
            <div class="card">
              <div class="card-body">
                <MonsterLookup :monster="monster" @hit="monsterSelected"></MonsterLookup>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <GearSetup :monster="monster" :player="player" :setup="setup"
                       @update="(set) => {this.setup = set; this.save()} "></GearSetup>
          </div>

          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <h2>Available Upgrades</h2>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <ResultSet :monster="monster" :player="player" :setup="setup"></ResultSet>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="row mt-2 mb-2">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <InArticleAdsense
              style="display:block; text-align:center;"
              data-ad-layout="in-article"
              data-ad-format="fluid"
              data-ad-client="ca-pub-6075100011305267"
              data-ad-slot="3433025857"
              :is-non-personalized-ads="false"
              :data-full-width-responsive="true">
            </InArticleAdsense>
          </div>
        </div>
      </div>
    </div>


    <div class="row mt-2 mb-2">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3">Tool Made Possible By</h5>
            <SponsorContainer></SponsorContainer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PlayerLookup from "../components/PlayerLookup";
  import MonsterLookup from "../components/MonsterLookup";
  import InventoryContainer from "../components/InventoryContainer";
  import GearCompare from "../components/GearCompare";
  import EquipmentBonus from "../components/gear-selector/EquipmentBonus";
  import MonsterBonus from "../components/gear-selector/MonsterBonus";
  import PlayerStats from "../components/PlayerStats";
  import Sponsor from "../components/Sponsor";
  import SponsorContainer from "../components/SponsorContainer";
  import GearSetup from "../components/gear-selector/GearSetup";
  import ResultSet from "../components/ResultSet";

  export default {
    name: 'DPSCalc',
    components: {
      ResultSet,
      GearSetup,
      SponsorContainer,
      Sponsor,
      PlayerStats,
      EquipmentBonus,
      GearCompare,
      MonsterBonus,
      InventoryContainer,
      MonsterLookup,
      PlayerLookup
    },
    data() {
      return {
        highscoreLookupError: null,
        items: [],
        player: {
          onTask: false,
          isDefault: true,
          attack: {level: 0},
          strength: {level: 0},
          defence: {level: 0},
          ranged: {level: 0},
          prayer: {level: 0},
          magic: {level: 0},
          hitpoints: {level: 0},
          combat: {level: 0},
        },
        setup: {
          activeSpell: null,
          activeStance: null,
          activeSpellbook: 'standard',
          potions: require('@/assets/data/potions/default.json'),
          prayers: {},
          equipment: {
            head: {id: 0},
            cape: {id: 0},
            neck: {id: 0},
            ammo: {id: 0},
            weapon: {id: 0, weapon: {stances: []}},
            body: {id: 0},
            shield: {id: 0},
            legs: {id: 0},
            hands: {id: 0},
            feet: {id: 0},
            ring: {id: 0},
            blowpipe_ammo: {id: 0},
          },
          settings: {
            onTask: true,
            kandarinDiary: false,
          },
        },
        monster: null,
      }
    },
    methods: {
      getItems: function () {
        this.$http.get('https://www.osrsbox.com/osrsbox-db/items-search.json').then((resp) => {
          this.items = resp.data;
        })
      },
      monsterSelected: function (monster) {
        this.monster = monster;
      },

      loadLocalStorage: function () {
        let monster = localStorage.getItem("osrs:compare:monster");
        if (monster !== null) {
          this.monsterSelected(JSON.parse(monster))
        }

      },
      loadShare: function (id) {
        console.log('Share mode detected', id);

        //TODO Switch share input based on what id is returned
        const uri = `${process.env.API_ADDR}/share/s/${id}`;
        this.$http.get(uri).then((resp) => {
          console.log('share data returned', resp.data);

          if (resp.data.cid === "gear-setup") {
            this.setup = JSON.parse(resp.data.data)
          }


        }).catch((resp) => {
          if (resp.data === "" || resp.status !== 200) {
            //TODO Toast notification
            // this.loadLocalStorage();
            return;
          }
        })

      },
    },
    mounted() {
      this.loadLocalStorage()

      if (this.$route.query.s) {
        this.loadShare(this.$route.query.s);
        return;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/GearUpgrade.vue